import {
  Button,
  Input,
  InputRef,
  Modal,
  Popconfirm,
  Space,
  Table,
  notification,
} from "antd";
import NoPosition from "../../assets/vectors/NoPositionVector.png";
import {
  fetchUserPosition,
  getMyPosition,
} from "../../features/position/positionSlice";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import CustomButton from "../share/customButton";
import { ColorPalette } from "../share/color/colorPalette";
import { ColumnType, ColumnsType } from "antd/es/table";
import {
  SendInvitationSms,
  UpdateInvitation,
} from "../../services/InvitationService";
import SearchOutlined from "@ant-design/icons/lib/icons/SearchOutlined";
import Highlighter from "react-highlight-words";
import { NotificationPlacement } from "antd/es/notification/interface";
import ConvertToShamsi from "../../extentions/convertors/ConvertToShamsi";
import { FilterConfirmProps } from "antd/es/table/interface";
import { GURL } from "../../services/global";
import axios from "axios";
import { GetPositionRoleByPositionIdAndRole } from "../../services/PositionService";
import PersonelInvitations from "./PersonelInvitations";

const PersonelInvitationView = () => {
  const [api, contextHolder] = notification.useNotification();
  const dispatch = useDispatch<any>();
  const myPositions = useSelector(getMyPosition);
  const [SendInvitation, setSendInvitation] = useState(false);
  const [getNewInvitationDialog, SetNewInvitationDialog] = useState(false);
  const [take, setTake] = useState(10);
  const [GetInvitationData, SetInvitaionData] = useState<any>(null);

  //Sorting Methode Start
  const compareValues = (a: any, b: any) => {
    // Handle different data types and null/undefined values
    if (typeof a === "string" && typeof b === "string") {
      return a.localeCompare(b);
    } else {
      return a - b;
    }
  };

  //Sorting Methode End
  async function GetPositionRoleByPositionIdAndRoleAsync() {
    await GetPositionRoleByPositionIdAndRole(
      myPositions.positions.id,
      "SendInvitation"
    ).then((p) => setSendInvitation(p.data.data));
  }

  useEffect(() => {
    if (myPositions) {
      if (myPositions.positions.name !== undefined) {
        GetPositionRoleByPositionIdAndRoleAsync();
      }
    }
  }, [myPositions]);

  const LoadInvitations = () => {
    axios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${localStorage.getItem("token")}`;
    axios
      .get(
        `${GURL}/company/v1/Invitations?phoneNumber=${1}&take=${take}&&type=${0}`
      )
      .then((response) => {
        //console.log("IdD",response?.data?.data);

        SetInvitaionData(response?.data?.data);
      });
  };
  useEffect(() => {
    LoadInvitations();
  }, [take]);
  // Load Invitations End

  //Search and Filter Operations Start
  interface DataType {
    key: string;
    firstName: string;
    lastName: string;
    phoneNumber: string;
  }
  type DataIndex = keyof DataType;
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef<InputRef>(null);
  const handleSearch = (
    selectedKeys: string[],
    confirm: (param?: FilterConfirmProps) => void,
    dataIndex: DataIndex
  ) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters: () => void) => {
    clearFilters();
    setSearchText("");
  };
  const getColumnSearchProps = (dataIndex: any): ColumnType<any> => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <Input
          ref={searchInput}
          placeholder={`جستجو ${"..."}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            handleSearch(selectedKeys as string[], confirm, dataIndex)
          }
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() =>
              handleSearch(selectedKeys as string[], confirm, dataIndex)
            }
            icon={<SearchOutlined rev={undefined} />}
            size="small"
            style={{ width: 90 }}
          >
            جستجو
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            پاک کردن
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            بستن
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered: boolean) => (
      <SearchOutlined
        style={{ color: filtered ? "#1677ff" : undefined }}
        rev={undefined}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ?.toString()
        .toLowerCase()
        .includes((value as string).toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  //Search and Filter Operations End
  //Notifications Start

  const openNotification = (msg: any, placement: NotificationPlacement) => {
    const key = `open${Date.now()}`;
    const btn = (
      <Space>
        <Button
          className="iran"
          type="link"
          size="small"
          onClick={() => api.destroy()}
        >
          رد کردن
        </Button>
      </Space>
    );
    api.info({
      message: "پیام",
      description: msg,
      placement,
      btn,
      key,
      className: "iran",
      onClose: close,
    });
  };
  const close = () => {
    console.log(
      "Notification was closed. Either the close button was clicked or duration time elapsed."
    );
  };

  //Notifications End
  //Update Invitation Start
  async function UpdateInvitationAsync(state: number, invitationId: any) {
    await UpdateInvitation({
      invitationId: invitationId,
      invitationState: state,
    })
      .then(() => LoadInvitations())
      .then(() =>
        openNotification("دعوتنامه مورد نظر شما منقضی شد", "bottomRight")
      );
  }
  //Update Invitation End

  // Check Days Passed
  function checkIfThreeDaysPassed(latestSmsSentDate: string): boolean {
    const today = new Date();
    const sentDate = new Date(latestSmsSentDate);
    const todayUTC = Date.UTC(
      today.getUTCFullYear(),
      today.getUTCMonth(),
      today.getUTCDate()
    );
    const sentDateUTC = Date.UTC(
      sentDate.getUTCFullYear(),
      sentDate.getUTCMonth(),
      sentDate.getUTCDate()
    );
    const differenceInTime = todayUTC - sentDateUTC;
    const differenceInDays = differenceInTime / (1000 * 3600 * 24);
    return differenceInDays >= 3;
  }
  //End Check Days Passed

  //Table Column Start
  const columnsTotal: ColumnsType<any> = [
    {
      title: "#",
      dataIndex: "#",
      key: "#",
      width: "5%",
      render: (item, record, index) => <>{index + 1}</>,
    },
    {
      title: "نام و نام خانوادگی",
      dataIndex: "fullName",
      key: "fullName",
      width: "15%",
      ...getColumnSearchProps("fullName"),
      sorter: (a, b) => compareValues(a.fullName, b.fullName),
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "عنوان سمت",
      dataIndex: "position",
      key: "position",
      width: "15%",
      ...getColumnSearchProps("position"),
      sorter: (a, b) => compareValues(a.position, b.position),
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "تلفن همراه",
      dataIndex: "phoneNumber",
      key: "phoneNumber",
      width: "15%",
      ...getColumnSearchProps("phoneNumber"),
      render: (item, record, index) => (
        <>
          {record.phoneNumber === "0" ? "ارسال با ایمیل" : record.phoneNumber}
        </>
      ),
      sorter: (a, b) => compareValues(a.phoneNumber, b.phoneNumber),
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "وضعیت",
      dataIndex: "latestEvent",
      key: "latestEvent",
      width: "10%",
      ...getColumnSearchProps("latestEvent"),
      sorter: (a, b) => compareValues(a.latestEvent, b.latestEvent),
      sortDirections: ["descend", "ascend"],
    },

    {
      title: "تاریخ ارسال",
      dataIndex: "createdDate",
      key: "createdDate",
      width: "15%",

      render: (item, record, index) => (
        <>{ConvertToShamsi(record.createdDate)}</>
      ),
      sorter: (a, b) => compareValues(a.createdDate, b.createdDate),
      sortDirections: ["descend", "ascend"],
    },

    {
      title: "عملیات",
      dataIndex: "createdDate",
      key: "createdDate",
      width: "25%",

      render: (item, record, index) => (
        <>
          {record.latestEventState === 0 ? (
            <>
              <div>
                {checkIfThreeDaysPassed(record.latestSmsSentDate) &&
                record.phoneNumber !== "0" ? (
                  <>
                    <CustomButton
                      className="mx-1"
                      LeftIconEnabled={false}
                      RightIconEnabled={false}
                      hasTitle={true}
                      customType="Secondary"
                      customSize="Large"
                      onClick={() => {
                        SendInvitationSms(record.id)
                          .then(() => LoadInvitations())
                          .then(() =>
                            openNotification(
                              "متن دعوتنامه مجددا پیامک شد",
                              "bottomRight"
                            )
                          );
                      }}
                    >
                      ارسال مجدد
                    </CustomButton>
                  </>
                ) : (
                  <></>
                )}

                <Popconfirm
                  title="آیا از منقضی کردن ردیف مطمئن هستید؟"
                  okText="بله"
                  cancelButtonProps={{
                    className: "ant-btn-primary ant-btn-dangerous",
                    style: {
                      color: "white",
                    },
                  }}
                  cancelText="خیر"
                  onConfirm={() => UpdateInvitationAsync(4, record.id)}
                >
                  <a>
                    <CustomButton
                      className="mx-1"
                      style={{
                        color: ColorPalette.red[300],
                        backgroundColor: ColorPalette.red[100],
                        borderColor: ColorPalette.red[300],
                      }}
                      LeftIconEnabled={false}
                      RightIconEnabled={false}
                      hasTitle={true}
                      customType="Secondary"
                      customSize="Large"
                    >
                      منقضی کردن
                    </CustomButton>
                  </a>
                </Popconfirm>
              </div>
            </>
          ) : (
            <></>
          )}
        </>
      ),
    },
  ];
  //Table Column End

  const handleComponentChange = () => {
    LoadInvitations();
    SetNewInvitationDialog(false);
  };

  return (
    <>
      {contextHolder}
      {getMyPosition !== null ? (
        <>
          <div className="col-12  mt-2" style={{ display: "" }}>
            <div className="d-block">
              {SendInvitation === true ? (
                <>
                  <Button
                    onClick={() => {
                      SetNewInvitationDialog(true);
                      // openNotification("درحال بروزرسانی", "bottomRight");
                    }}
                    style={{
                      fontSize: "0.8em",
                    }}
                    className="iran p-button-rounded"
                  >
                    دعوتنامه جدید
                  </Button>
                  <Button
                    onClick={() => {
                      setTake(100000);
                      //here
                    }}
                    style={{
                      fontSize: "0.8em",
                    }}
                    className="px-2  mx-2 iran p-button-rounded"
                  >
                    نمایش همه دعوتنامه ها
                  </Button>
                </>
              ) : (
                <></>
              )}
            </div>
            <div
              dir="rtl"
              className="mt-2 ag-theme-alpine"
              style={{ width: "100%", maxHeight: "300px" }}
            >
              <Table
                size="small"
                scroll={{ y: 460 }}
                dataSource={GetInvitationData}
                pagination={false}
                columns={columnsTotal}
              />
            </div>
            <Modal
              open={getNewInvitationDialog}
              footer={null}
              onCancel={() => SetNewInvitationDialog(false)}
            >
              <div>
                <PersonelInvitations
                  onComponentChange={handleComponentChange}
                />
              </div>
            </Modal>
          </div>
        </>
      ) : (
        <>
          {" "}
          <div
            className="mt-5 iran"
            style={{ textAlign: "center", margin: "auto" }}
          >
            <p>کاربر گرامی شما دارای هیچ سمتی در هیچ فروشگاهی نمیباشید . </p>
            <img height={300} width={300} src={NoPosition} />
          </div>
        </>
      )}
    </>
  );
};
export default PersonelInvitationView;
